import React from 'react';

function Notice({ message }) {
  return (
    <div className="notice notice--error u--margin-bottom-50">
      <strong>{message}</strong>
    </div>
  );
}

export default Notice;
